import { FC } from 'react';
import styles from './DraftSticker.module.scss';

const DraftSticker: FC = () => {
  return <span className={`${styles.coverSticker} ${styles.coverSticker_draft}`}>Черновик</span>;
};

export default DraftSticker;
